export enum SmartpricingIntegrationState {
  NEW = "new",
  RATE_PLANS_SELECTED = "rate_plans_selected",
  ROOMS_AND_RATES_SENT = "rooms_and_rates_sent",
  ROOMS_AND_RATES_CONFIRMED = "rooms_and_rates_confirmed",
  BULK_RESERVATIONS_SENT = "bulk_reservations_sent",
  BULK_RESERVATIONS_CONFIRMED = "bulk_reservations_confirmed",
  COMPLETED = "completed",
}
